// extracted by mini-css-extract-plugin
export var clone = "_ox-2";
export var displayNone = "_ox-4";
export var expandableItem = "_ox-5";
export var expanded = "_ox-6";
export var folderItem = "_ox-7";
export var ghost = "_ox-1";
export var hidden = "_ox-3";
export var pipeContainer = "_ox-8";
export var wrapper = "_ox-0";